import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import Login from "../login/login";
import "./demo.css";
import MainRoute from '../official_web/main_route';
import { Helmet } from 'react-helmet';

import { Mainlayout } from '../ui/ot';
import NavBarBackend from './../../theme/layout_backend2'
import RouteOrganizationStructure from './../../components/organization_structure/MainRoute';
import MainRouteLibrary from './../../components/Library/MainRoute'
import MainRouteLibraryFront from './../../components/Library/MainRouteFront'
import LibraryLayout from '../Library/views/Layout'
import AppMainRoute from "../../pages/app/MainRoute"
import LatestNewsPage from '../official_web/components/LatestNewsPage'
import axios from "axios";


const RouteOfficeWeb = ({
    admin = true
}) => {
    const mobile = localStorage?.getItem('mobile') || 'true';
    return (<>
        <Helmet>
            {mobile === 'true' &&
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            }
        </Helmet>
        <BrowserRouter>
            <Routes>
                <Route path={'login'}>
                    <Route index element={<Login logo="keyTravel" />} />
                </Route>
                <Route path={'/LatestNewsPage'} element={<LatestNewsPage />} />

                <Route index element={<Navigate to={admin ? "/officialweb/admin" : "/officialweb/frontend"} />} />

                <Route path={'/officialweb/*'} element={<MainRoute admin={admin} prefixTitle='國立高雄師範大學校園就業博覽會' />} />
                {/* true是要登入的 false是只會剩下形象的前台 */}
            </Routes>
        </BrowserRouter>
    </>);
}
export default RouteOfficeWeb;


const JWT = () => {
    axios.interceptors.request.use(
        async (config) => {
            const access_token = localStorage.getItem("access_token");

            if (access_token) {
                config.headers = {
                    ...config.headers,
                    authorization: `Bearer ${access_token}`,
                };
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        function (error) {
            const access_token_url = "/access_token";
            const config = error.config;
            if (error.response?.status === 401 && config.url === access_token_url) {
                window.location.href = "/login";
                return Promise.reject(error);
            }

            if (error.response?.status === 401 && !config._retry) {
                config._retry = true;
                const refreshToken = localStorage.getItem("refresh_token");
                return axios
                    .post(access_token_url, {
                        refresh_token: refreshToken,
                    })
                    .then((res) => {
                        if (res?.status === 201) {
                            localStorage.setItem("access_token", res.data.access_token);
                            config.headers = {
                                ...config.headers,
                                authorization: `Bearer ${localStorage.getItem("access_token")}`,
                            };
                            return axios(config);
                        }
                    });
            }
            return Promise.reject(error);
        }
    );
    return <Outlet />;
};